import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Server, Loader2, Lock } from "lucide-react";

const LOGIN_BG =
  "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhdGElMjBuZXR3b3JrJTIwZGFya3xlbnwwfHx8fDE3ODYzNDc4Mjl8MA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email.trim(), password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-zinc-950 relative flex items-center justify-center px-4 bg-[radial-gradient(#27272a_1px,transparent_1px)] [background-size:16px_16px]">
      <img
        src={LOGIN_BG}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]"
      />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-sm border border-emerald-500/30 bg-emerald-500/10 drop-shadow-[0_0_8px_rgba(16,185,129,0.25)]">
            <Server className="h-5 w-5 text-emerald-400" />
          </div>
          <div>
            <h1 className="font-heading text-xl font-bold tracking-tight text-zinc-50">IPTV Bridge</h1>
            <p className="font-mono text-xs uppercase tracking-wider text-zinc-500">Emby-Compatible Server</p>
          </div>
        </div>

        <div className="rounded-sm border border-zinc-800 bg-zinc-900 p-6">
          <div className="mb-6 flex items-center gap-2 text-zinc-300">
            <Lock className="h-4 w-4 text-emerald-400" />
            <h2 className="font-heading text-lg font-semibold tracking-tight">Admin Access</h2>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="mb-1.5 block font-mono text-xs uppercase tracking-wider text-zinc-500">
                Email
              </label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="admin@bridge.local"
                className="w-full rounded-sm border border-zinc-800 bg-zinc-950 px-3 py-2 font-mono text-sm text-zinc-100 outline-none transition-colors duration-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500/50"
              />
            </div>
            <div>
              <label className="mb-1.5 block font-mono text-xs uppercase tracking-wider text-zinc-500">
                Password
              </label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="w-full rounded-sm border border-zinc-800 bg-zinc-950 px-3 py-2 text-sm text-zinc-100 outline-none transition-colors duration-200 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500/50"
              />
            </div>

            {error && (
              <p data-testid="login-error" className="rounded-sm border border-red-500/20 bg-red-500/10 px-3 py-2 text-sm text-red-400">
                {error}
              </p>
            )}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="flex w-full items-center justify-center gap-2 rounded-sm bg-emerald-600 px-4 py-2.5 font-medium text-white transition-colors duration-200 hover:bg-emerald-500 disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {loading ? "Authenticating…" : "Sign In"}
            </button>
          </form>
        </div>
        <p className="mt-4 text-center font-mono text-xs text-zinc-600">
          Repurpose the free Emby app as a clean IPTV player.
        </p>
      </div>
    </div>
  );
}
